import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { ProductCartViewComponent } from './products/product-cart-view/product-cart-view.component';
import { ProductCheckoutComponent } from './products/product-checkout/product-checkout.component';

export const routes: Routes = [
  { path: '', redirectTo: '', pathMatch: 'full' },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'service',
        loadChildren: () =>
          import('./category-service/category-service.module').then(
            (m) => m.CategoryServiceModule
          ),
      },
      {
        path: 'b2b',
        loadChildren: () =>
          import('./b2-b/b2-b.module').then((m) => m.B2BModule),
      },
      {
        path: 'leads',
        loadChildren: () =>
          import('./leads/leads.module').then((m) => m.LeadsModule),
      },
      {
        path: 'service/provider/detail/:subCategory/:name/:location',
        loadComponent: () =>
          import('./category-service/service-providers-profile/service-providers-profile.component').then(
            (m) => m.ServiceProvidersProfileComponent
          ),
      },
      {
        path: 'architecture-plan',
        loadComponent: () =>
          import('./house-plans/house-plans.component').then(
            (m) => m.HousePlansComponent
          ),
      },
      {
        path: '2-d-layout-plan',
        loadComponent: () =>
          import('./house-plans/two-d-layout-plan/two-d-layout-plan.component').then(
            (m) => m.TwoDLayoutPlanComponent
          ),
      },
      {
        path: '3-d-front-elevation',
        loadComponent: () =>
          import('./house-plans/three-d-layout-plan/three-d-layout-plan.component').then(
            (m) => m.ThreeDLayoutPlanComponent
          ),
      },
      {
        path: 'structural-drawing',
        loadComponent: () =>
          import('./house-plans/structural-layout-plan/structural-layout-plan.component').then(
            (m) => m.StructuralLayoutPlanComponent
          ),
      },
      {
        path: 'presentation-plan',
        loadComponent: () =>
          import('./house-plans/presentation-plan/presentation-plan.component').then(
            (m) => m.PresentationPlanComponent
          ),
      },

      {
        path: 'terms-of-use',
        loadComponent: () =>
          import('./terms-of-use/terms-of-use.component').then(
            (m) => m.TermsOfUseComponent
          ),
      },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('./privacy-policy/privacy-policy.component').then(
            (m) => m.PrivacyPolicyComponent
          ),
      },
      {
        path: 'complain',
        loadComponent: () =>
          import('./Help/complain/complain.component').then(
            (m) => m.ComplainComponent
          ),
      },
      {
        path: 'feedback',
        loadComponent: () =>
          import('./Help/feedback/feedback.component').then(
            (m) => m.FeedbackComponent
          ),
      },
      {
        path: 'contact-us',
        loadComponent: () =>
          import('./Help/contact-us/contact-us.component').then(
            (m) => m.ContactUsComponent
          ),
      },

      {
        path: 'plans',
        loadChildren: () =>
          import('./advertisement/advertisement.module').then(
            (m) => m.AdvertisementModule
          ),
      },
      {
        path: 'articles',
        loadChildren: () =>
          import('./articels/articels.module').then((m) => m.ArticelsModule),
      },
      {
        path: 'raw-material',
        loadChildren: () =>
          import('./raw-material/raw-material.module').then(
            (m) => m.RawMaterialModule
          ),
      },
      {
        path: 'product',
        loadChildren: () =>
          import('./products/products.module').then((m) => m.ProductsModule),
      },

      {
        path: 'weddings',
        loadChildren: () =>
          import('./weddings/weddings.module').then((m) => m.WeddingsModule),
      },
      {
        path: 'hotels-list/:location',
        loadComponent: () =>
          import('./tour_travel_hotels/hotels-list/hotels-list.component').then((m) => m.HotelsListComponent),
      },
      {
        path: 'hotels-details/:id',
        loadComponent: () =>
          import('./tour_travel_hotels/hotels-list/hotels-details/hotels-details.component').then((m) => m.HotelsDetailsComponent),
      },
      {
        path: 'tour-and-transit',
        loadComponent: () =>
          import('./tour-and-transit/tour-and-transit.component').then((m) => m.TourAndTransitComponent),
      },
      {
        path: 'book-bus',
        loadComponent: () =>
          import('./tour_travel_hotels/bus-train-bus-list/bus-train-bus-list.component').then((m) => m.BusTrainBusListComponent),
      },
      {
        path: 'book-flight',
        loadComponent: () =>
          import('./tour_travel_hotels/bus-train-bus-list/bus-train-bus-list.component').then((m) => m.BusTrainBusListComponent),
      },
      {
        path: 'book-train',
        loadComponent: () =>
          import('./tour_travel_hotels/bus-train-bus-list/bus-train-bus-list.component').then((m) => m.BusTrainBusListComponent),
      },
      {
        path: 'train-details',
        loadComponent: () =>
          import('./tour_travel_hotels/bus-train-bus-list/bus-train-bus-list-details/bus-train-bus-list-details.component').then((m) => m.BusTrainBusListDetailsComponent),
      },
      {
        path: 'bus-details',
        loadComponent: () =>
          import('./tour_travel_hotels/bus-train-bus-list/bus-train-bus-list-details/bus-train-bus-list-details.component').then((m) => m.BusTrainBusListDetailsComponent),
      },
      {
        path: 'flight-details',
        loadComponent: () =>
          import('./tour_travel_hotels/bus-train-bus-list/bus-train-bus-list-details/bus-train-bus-list-details.component').then((m) => m.BusTrainBusListDetailsComponent),
      },
      {
        path: 'account',
        loadChildren: () =>
          import('./account/account.module').then(
            (m) => m.AccountModule
          ),
      },
      {
        path: 'cart',
        component: ProductCartViewComponent,
      },
      {
        path: 'check-out',
        component: ProductCheckoutComponent,
      },
      {
        path: 'search',
        loadComponent: () =>
          import('./user-searched/user-searched.component').then((m) => m.UserSearchedComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' }
];
